export type PREVIOUS_PAGE_IDENTIFIER = (typeof PREVIOUS_PAGE_IDENTIFIER)[keyof typeof PREVIOUS_PAGE_IDENTIFIER];
export const PREVIOUS_PAGE_IDENTIFIER = {
  /** チェックイン検索 */
  CHECKIN_SEARCH: 'checkinSearch',
  /** チェックイン状況詳細 */
  CHECKIN_STATUS: 'checkinStatus',
  /** チェックイン対象選択 */
  CHECKIN_SELECT: 'checkinSelect',
  /** チェックイン搭乗者情報入力 */
  CHECKIN_PASSENGER_INPUT: 'checkinPassengerInput',
  /** チェックイン確認 */
  CHECKIN_REVIEW: 'checkinReview',
  /** チェックインシートマップ */
  CHECKIN_SEATMAP: 'checkinSeatmap',
  /** 予約詳細 */
  SERVICING_MY_BOOKING: 'myBooking',
  /** チェックイン完了 */
  CHECKIN_COMPLETED: 'checkinCompleted',
  /** 空港空席待ち人数検索 */
  CHECKIN_WAITING_SEARCH: 'checkinWaitingSearch',
  /** 空港空席待ち人数照会結果 */
  CHECKIN_WAITING_NUMBER: 'checkinWaitingNumber',
  /** 空席待ち照会結果 */
  CHECKIN_STANDBY_FLIGHT_AVAILABILITY: 'standbyAvailability',
  /** エントリー内容確認 */
  CHECKIN_STANDBY_REVIEW: 'checkinStandbyReview',
  /** 空席待ちエントリー完了 */
  STANDBY_COMPLETED: 'standbyCompleted',
  /** 空席照会結果(国内) */
  FLIGHT_AVAILABILITY: 'flightAvailability',
  /** アップグレード対象フライト選択 */
  UPGRADE_FLIGHT_SELECT: 'upgradeFlightSelect',
} as const;
